// import React from 'react';
// import data from '../../ourDoctors.json';

// const { bookConsultation } = data;

// const BookConsultation = () => {
//   const {
//     id,
//     badge,
//     heading,
//     description,
//     address,
//     hours,
//     cta,
//     availability,
//     footnote,
//   } = bookConsultation;

//   return (
//     <section
//       id={id}
//     //   className="w-full py-10 md:py-14"
//     //   style={{ backgroundColor: 'var(--light-blue)' }}
//     >
//       <div className="container mx-auto px-0">
//         <div
//           className="px-6 py-8 md:px-10 md:py-10"
//           style={{
//             backgroundColor: '#EBEEF4',
//             boxShadow: '0 2px 20px rgba(0,36,107,0.06)',
//           }}
//         >
//           <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">

//             {/* ── Left Panel ── */}
//             <div className="w-full lg:w-1/2 flex flex-col justify-between gap-6">
//               <div className="flex flex-col gap-4">

//                 {/* Badge */}
//                 <p
//                   className="text-sm font-medium"
//                   style={{ color: 'var(--text-light)' }}
//                 >
//                   {badge}
//                 </p>

//                 {/* Heading */}
//                 <h2
//                   className="font-bold leading-tight"
//                   style={{
//                     color: 'var(--primary-color)',
//                     fontSize: 'clamp(1.5rem, 3vw, 2.2rem)',
//                   }}
//                 >
//                   {heading.split('\n').map((line, i) => (
//                     <span key={i} className="block">{line}</span>
//                   ))}
//                 </h2>

//                 {/* Description */}
//                 <p
//                   className="text-sm md:text-base leading-relaxed primary-text"
//                   style={{ maxWidth: '440px' }}
//                 >
//                   {description}
//                 </p>

//                 {/* Address */}
//                 <div className="flex flex-col gap-2">
//                   <div className="flex items-start gap-2">
//                     {/* Location icon */}
//                     <svg
//                       className="flex-shrink-0 mt-0.5"
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       style={{ color: 'var(--primary-color)' }}
//                     >
//                       <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
//                       <circle cx="12" cy="10" r="3" />
//                     </svg>
//                     <span className="text-sm primary-text">
//                       {address}
//                     </span>
//                   </div>

//                   <div className="flex items-start gap-2">
//                     {/* Clock icon */}
//                     <svg
//                       className="flex-shrink-0 mt-0.5"
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       style={{ color: 'var(--primary-color)' }}
//                     >
//                       <circle cx="12" cy="12" r="10" />
//                       <polyline points="12 6 12 12 16 14" />
//                     </svg>
//                     <span className="text-sm primary-text">
//                       {hours}
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               {/* CTA Button */}
//               <div>
//                 <a
//                   href={cta.href}
//                   className="btn-primary inline-block rounded-md font-semibold"
//                   style={{ padding: '0.65rem 1.75rem', fontSize: '0.9rem' }}
//                 >
//                   {cta.label}
//                 </a>
//               </div>
//             </div>

//             {/* Vertical divider — desktop only */}
//             <div
//               className="hidden lg:block w-px self-stretch flex-shrink-0"
//               style={{ backgroundColor: '#d1d6ef' }}
//             />

//             {/* ── Right Panel: Weekly Availability ── */}
//             <div className="w-full lg:w-1/2 flex flex-col gap-4">
//               <h3
//                 className="font-semibold text-base md:text-lg"
//                 style={{ color: 'var(--primary-color)' }}
//               >
//                 {availability.heading}
//               </h3>

//               <div className="flex flex-col gap-2">
//                 {availability.schedule.map((slot) => {
//                   const isOpen = !slot.closed;
//                   return (
//                     <div
//                       key={slot.id}
//                       className="flex items-center justify-between rounded-xl px-4 py-3"
//                       style={{ backgroundColor: 'var(--white, #fff)' }}
//                     >
//                       {/* Day + dot */}
//                       <div className="flex items-center gap-3">
//                         <span
//                           className="w-2 h-2 rounded-full flex-shrink-0"
//                           style={{
//                             backgroundColor: isOpen
//                               ? 'var(--primary-color)'
//                               : 'var(--gray-300)',
//                           }}
//                         />
//                         <span
//                           className="text-sm"
//                           style={{
//                             color: isOpen ? 'var(--primary-color)' : 'var(--text-light)',
//                           }}
//                         >
//                           {slot.day}
//                         </span>
//                       </div>

//                       {/* Time or Closed */}
//                       <span
//                         className="text-sm"
//                         style={{
//                           color: isOpen ? 'var(--text-dark)' : 'var(--text-light)',
//                           fontWeight: isOpen ? 500 : 400,
//                         }}
//                       >
//                         {slot.closed ? 'Closed' : slot.time}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//           </div>

//           {/* ── Footnote ── */}
//           {footnote && (
//             <p
//               className="text-center text-sm mt-8 md:mt-10 primary-text"
//             >
//               {footnote}
//             </p>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BookConsultation;

// import React from 'react';
// import data from '../../ourDoctors.json';

// const { bookConsultation } = data;
// export const formatTime = (time) => {
//   if (!time) return "";

//   const [hour, minute] = time.split(":");

//   const date = new Date();
//   date.setHours(Number(hour), Number(minute));

//   return date.toLocaleTimeString("en-US", {
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//   });
// };
// const BookConsultation = () => {
//   const {
//     id,
//     badge,
//     heading,
//     description,
//     address,
//     hours,
//     cta,
//     availability,
//     footnote,
//   } = bookConsultation;

//   return (
//     <section
//       id={id}
//       className="w-full py-10 md:py-14 ava-card-bg"
//       // style={{ backgroundColor: '#EBEEF4' }}
//     >

//       <div className="container mx-auto px-4 md:px-8 lg:px-12">
//         <div className="px-0">
//           <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 text-center md:text-left">

//             {/* ── Left Panel ── */}
//             <div className="w-full lg:w-1/2 flex flex-col justify-between gap-6 lg:pl-12 text-center md:text-left">
//               <div className="flex flex-col gap-4 text-center md:text-left">

//                 {/* Badge */}
//                 <p className="ava-text-subheading "
//                 //  style={{ color: 'var(--text-light)'}}
//                  >
//                   {badge}
//                 </p>

//                 {/* Heading */}
//                 <h2
//                   className="ava-heading-lg "
//                 >
//                   {heading.split('\n').map((line, i) => (
//                     <span key={i} className="block">{line}</span>
//                   ))}
//                 </h2>

//                 {/* Description */}
//                 <p
//                   className="ava-text-body  "
//                   // style={{ maxWidth: '440px' }}
//                 >
//                   {description}
//                 </p>

//                 {/* Address + Hours */}
//                 <div className="flex flex-col gap-2 mx-auto md:mx-0">
//                   <div className="flex items-start gap-2 text-center md:text-left">
//                     <svg className="flex-shrink-0 mt-0.5" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
//                       <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
//                       <circle cx="12" cy="10" r="3" />
//                     </svg>
//                     <span className="ava-text-body ">{address}</span>
//                   </div>

//                   <div className="flex items-start gap-2">
//                     <svg className="flex-shrink-0 mt-0.5" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                       <circle cx="12" cy="12" r="10" />
//                       <polyline points="12 6 12 12 16 14" />
//                     </svg>
//                     <span className="ava-text-body ">{hours}</span>
//                   </div>
//                 </div>
//               </div>

//               {/* CTA Button */}
//               <div>
//                 <a
//                   href={cta.href}
//                   className="btn-primary "
//                   // style={{ padding: '0.65rem 1.75rem', fontSize: '0.9rem' }}
//                 >
//                   {cta.label}
//                 </a>
//               </div>
//             </div>

//             {/* Vertical divider — desktop only */}
//             <div
//               className="hidden lg:block w-px self-stretch flex-shrink-0"
//               style={{ backgroundColor: 'var(--ava-border-color)' }}
//             />

//             {/* ── Right Panel: Weekly Availability ── */}
//             <div className="w-full lg:w-1/2 flex flex-col gap-4 mx-auto md:mx-0">
//               <h3
//                 className="ava-text-subheading "
//                 // style={{ color: 'var(--primary-color)' }}
//               >
//                 {availability.heading}
//               </h3>

//               {/*
//                 Schedule cards:
//                   — max-width caps the card width so they don't stretch end-to-end
//                   — mx-auto centres them within the right column
//                   — On mobile they go full-width; on lg they're capped at 420px
//               */}
//               <div className="flex flex-col gap-2 mx-auto md:mx-0">
//                 {availability.schedule.map((slot) => {
//                   const isOpen = !slot.closed;
//                   return (
//                     <div
//                       key={slot.id}
//                       className="flex items-center justify-between rounded-xl px-4 py-3"
//                       style={{
//                         backgroundColor: 'var(--white, #fff)',
//                         maxWidth: '420px',     /* ← reduced card width */
//                       }}
//                     >
//                       {/* Day + dot */}
//                       <div className="flex items-center gap-3">
//                         <span
//                           className="w-2 h-2 rounded-full flex-shrink-0"
//                           style={{
//                             backgroundColor: isOpen
//                               ? 'var(--primary-color)'
//                               : 'var(--ava-color-disabled)',
//                           }}
//                         />
//                         <span
//                           className="ava-text-body "
//                           style={{
//                             color: isOpen ? 'var(--primary-color)' : 'var(--ava-color-disabled)',
//                           }}
//                         >
//                           {slot.day}
//                         </span>
//                       </div>

//                       {/* Time or Closed */}
//                       <span
//                         className="text-sm"
//                         style={{
//                           color: isOpen ? 'var(--text-dark)' : 'var(--ava-color-disabled)',
//                           fontWeight: isOpen ? 500 : 400,
//                         }}
//                       >
//                         {slot.closed ? 'Closed' : slot.time}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//           </div>

//           {/* ── Footnote ── */}
//           {footnote && (
//             <p className="text-center mt-8 md:mt-10 ava-text-body">
//               {footnote}
//             </p>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BookConsultation;

import React from 'react';
import data from '../../ourDoctors.json';

const { bookConsultation } = data;
export const formatTime = (time) => {
  if (!time) return "";

  const [hour, minute] = time.split(":");

  const date = new Date();
  date.setHours(Number(hour), Number(minute));

  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const BookConsultation = ({schedule}) => {
  const {
    id,
    badge,
    heading,
    description,
    address,
    hours,
    cta,
    availability,
    footnote,
  } = bookConsultation;
  

  return (
    <section
      id={id}
      className="w-full ava-section-gap ava-card-bg py-10 md:py-14 "
      // style={{ backgroundColor: '#EBEEF4' }}
    >

      <div className="container mx-auto px-4 md:px-8 lg:px-12 ">
        <div className="px-0">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 text-center md:text-left">

            {/* ── Left Panel ── */}
            <div className="w-full lg:w-1/2 flex flex-col justify-between gap-6 lg:pl-12 text-center md:text-left">
              <div className="flex flex-col gap-4 text-center md:text-left">

                {/* Badge */}
                <p className="ava-text-subheading "
                //  style={{ color: 'var(--text-light)'}}
                 >
                  {badge}
                </p>

                {/* Heading */}
                <h2
                  className="ava-heading-lg "
                >
                  {heading.split('\n').map((line, i) => (
                    <span key={i} className="block">{line}</span>
                  ))}
                </h2>

                {/* Description */}
                <p
                  className="ava-text-body  "
                  // style={{ maxWidth: '440px' }}
                >
                  {description}
                </p>

                {/* Address + Hours */}
                <div className="flex flex-col gap-2 mx-auto md:mx-0">
                  <div className="flex items-start gap-2 text-center md:text-left">
                    <svg className="flex-shrink-0 mt-0.5" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                    <span className="ava-text-body ">
                      {/* {address} */}
                      {Object.entries(schedule?.profile?.address ||{}).map(([key,value])=>value).filter(Boolean).join(",")}
                      </span>
                  </div>

                  <div className="flex items-start gap-2">
                    <svg className="flex-shrink-0 mt-0.5" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span className="ava-text-body ">{hours}</span>
                  </div>
                  <div className='flex items-start gap-2'>
                    <img src='/OurDoctors/pohnePrimary.svg' alt='contact' className='h-5 w-5'/>
                    <span className="ava-text-body ">+91-{schedule?.profile?.phone} </span>
                  </div>
                   <div className='flex items-start gap-2'>
                    <img src='/OurDoctors/mailPrimary.svg' alt='contact' className='h-5 w-5'/>
                    <span className="ava-text-body ">{schedule?.profile?.email}</span>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <div>
                <a
                  href={cta.href}
                  className="btn-primary "
                  // style={{ padding: '0.65rem 1.75rem', fontSize: '0.9rem' }}
                >
                  {cta.label}
                </a>
              </div>
            </div>

            {/* Vertical divider — desktop only */}
            <div
              className="hidden lg:block w-px self-stretch flex-shrink-0"
              style={{ backgroundColor: 'var(--ava-border-color)' }}
            />

            {/* ── Right Panel: Weekly Availability ── */}
            <div className="w-full lg:w-1/2 flex flex-col gap-4 mx-auto md:mx-0">
              <h3
                className="ava-text-subheading "
                // style={{ color: 'var(--primary-color)' }}
              >
                {availability.heading}
              </h3>

              {/*
                Schedule cards:
                  — max-width caps the card width so they don't stretch end-to-end
                  — mx-auto centres them within the right column
                  — On mobile they go full-width; on lg they're capped at 420px
              */}
              <div className="flex flex-col gap-2 mx-auto md:mx-0">
                {schedule?.schedulingSetup?.weeklySchedule.map((slot) => {
                  const isOpen = slot?.working; 
                  return (
                    <div
                      key={slot.id}
                      className=" flex items-center justify-between rounded-xl px-4 py-3"
                      style={{
                        backgroundColor: 'var(--white, #fff)',
                        maxWidth: '420px',     /* ← reduced card width */
                      }}
                    >
                      {/* Day + dot */}
                      <div className="flex items-center gap-3">
                        <span
                          className="w-2 h-2 rounded-full flex-shrink-0 "
                          style={{
                            backgroundColor: isOpen
                              ? 'var(--primary-color)'
                              : 'var(--ava-color-disabled)',
                          }}
                        />
                        <span
                          className="ava-text-body "
                          style={{
                            color: isOpen ? 'var(--primary-color)' : 'var(--ava-color-disabled)',
                          }}
                        >
                          {slot.dayOfWeek}
                        </span>
                      </div>

                      {/* Time or Closed */}
                      <span
                        className="text-sm"
                        style={{
                          color: isOpen ? 'var(--text-dark)' : 'var(--ava-color-disabled)',
                          fontWeight: isOpen ? 500 : 400,
                        }}
                      >
                        {/* {slot.closed ? 'Closed' : slot?.timeWindows?.map((item,index)=>(<div key={index}>{item.startTime} - {item.endTime} </div>))} */}
                       {!slot.working
  ? "Closed"
  : slot.timeWindows
      .map(
        (item) =>
          `${formatTime(item.startTime)} - ${formatTime(item.endTime)}`
      )
      .join(" & ")
}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>

          </div>

          {/* ── Footnote ── */}
          {footnote && (
            <p className="text-center mt-8 md:mt-10 ava-text-body">
              {footnote}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default BookConsultation;